/**
 * Contrat des écrans Clients et Clients bannis (kanban #870), SANS dépendance runtime : ce module
 * est exporté par le barrel (`index.ts`). Point de vérité unique des énumérations de
 * `GET /customers`, `GET /customers/banned` et `GET /customers/banned/overview` — les schémas Vine
 * du backend et les schémas Zod du back-office s'y réfèrent plutôt que de recopier les littéraux.
 */

/**
 * Fenêtres glissantes (jours) matérialisées dans `customer_stats` : une paire de colonnes
 * `amount_<n>d` / `carts_<n>d` par valeur. Périodes que `GET /customers` accepte (`period`).
 */
export const CUSTOMER_PERIODS = [30, 90, 365] as const
export type CustomerPeriod = (typeof CUSTOMER_PERIODS)[number]
export const DEFAULT_CUSTOMER_PERIOD: CustomerPeriod = 90

/** `active` : ≥ 1 panier validé sur 30 j ; `top` : top 10 % du CA 90 j. */
export const CUSTOMER_SEGMENTS = ['active', 'top'] as const
export type CustomerSegment = (typeof CUSTOMER_SEGMENTS)[number]

/** `no_card` (exige `read users.app-users.solvency`) ; `new` : compte créé sur 30 j. */
export const CUSTOMER_PROFILES = ['no_card', 'new'] as const
export type CustomerProfile = (typeof CUSTOMER_PROFILES)[number]

/** Tris serveur de `GET /customers`. */
export const CUSTOMER_SORTS = ['amount', 'carts', 'lastCart', 'lastEntry', 'created'] as const
export type CustomerSort = (typeof CUSTOMER_SORTS)[number]

export const SORT_DIRS = ['asc', 'desc'] as const
export type SortDir = (typeof SORT_DIRS)[number]

/** Tranches d'ancienneté de la dette (jours), bornes basses incluses. */
export const DEBT_AGE_BUCKETS = ['lt7', '7to30', '30to90', 'gt90'] as const
export type DebtAgeBucket = (typeof DEBT_AGE_BUCKETS)[number]

/** Tris serveur de `GET /customers/banned`. */
export const BANNED_CUSTOMER_SORTS = [
  'amount',
  'bannedSince',
  'unpaidCarts',
  'lastReminder',
  'name',
] as const
export type BannedCustomerSort = (typeof BANNED_CUSTOMER_SORTS)[number]

/** `never` : aucune relance journalisée — ni email de relance, ni lien de paiement envoyé. */
export const BANNED_REMINDER_FILTERS = ['never'] as const
export type BannedReminderFilter = (typeof BANNED_REMINDER_FILTERS)[number]

/** Borne haute de `pageSize` des deux listes (`vine.number().range([1, 100])`). */
export const CUSTOMERS_MAX_PAGE_SIZE = 100
